import { Component, OnInit, Input } from '@angular/core';
import { FieldComponent } from '../field/field.component';
import { ProvidehttpService } from '../providehttp.service';
import { ServiceStock } from '../service-stock.service';
import { Legend } from '@amcharts/amcharts4/charts';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.css']
})
export class ToggleSwitchComponent extends FieldComponent implements OnInit {

  @Input('checkedValue') checkedValue : any = true;
  @Input('uncheckedValue') uncheckedValue : any = false;
  @Input('cursor') cursor : any = '';
  

  constructor(services : ServiceStock) { 
    super(services);
    this.value = false;
  }

  getFieldInfo() {
    return (this.value==true)?"Yes":"No";
  }

  getFieldValue(){
    return (this.value==true)?this.checkedValue:this.uncheckedValue;
  }

  onBlur(){
    this.isOnFocus=false;
    this.blur.emit(this.getFieldValue());
  }

  setValue(value, additionalInfo = undefined) {
    this.value = (value==this.checkedValue);
    this.additionalInfo = additionalInfo;
    this.passNewValue(value);
  }
  // async validateValue(value, event=undefined): Promise<number> {
  //   var totalErrors: number = 0;
  //   if(this.value==true){
  //        return 0;
  //   }
  //   else{
  //     this.setError("Value Cannot be Empty");
  //     totalErrors++;
  //   }
  //   return totalErrors;
  // }
  ngOnInit() {
  }
}
